import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Faucet from './modules/faucet';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Faucet />
  </React.StrictMode>
);
